import { render, staticRenderFns } from "./address-validate.vue?vue&type=template&id=217b25a6&scoped=true"
import script from "./address-validate.vue?vue&type=script&lang=tsx"
export * from "./address-validate.vue?vue&type=script&lang=tsx"
import style0 from "./address-validate.vue?vue&type=style&index=0&id=217b25a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217b25a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('217b25a6')) {
      api.createRecord('217b25a6', component.options)
    } else {
      api.reload('217b25a6', component.options)
    }
    module.hot.accept("./address-validate.vue?vue&type=template&id=217b25a6&scoped=true", function () {
      api.rerender('217b25a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ops/address-validate.vue"
export default component.exports